import type { TOPIC_2_TYPE } from '@/types/taxonomyConst';
import { stringSort } from '@/utils/util';

const createTopicUtils = {
  getTargetTopicAlias: (topic: Topic2T<TOPIC_2_TYPE>) => {
    switch (topic.level) {
      case 1:
        return undefined;
      case 2:
        return topic.parent_topic_lv1?.parent_id;
      case 3:
        return topic.parent_topic_lv2?.parent_id;
      case 4:
        return topic.parent_topic_lv3?.parent_id;
      default:
        return undefined;
    }
  },
  compareRuleHasChange: (
    origin?: {
      op: any;
      values: any[];
    },
    compare?: {
      op: any;
      values: any[];
    },
  ) => {
    // 둘 다 존재하지 않는 경우
    if (!origin && !compare) return false;

    // 둘 다 존재하는 경우
    if (origin && compare) {
      if (origin.op !== compare.op) return true;
      const sortedOrigin = origin.values.sort(stringSort).toString();
      const sortedCompare = compare.values.sort(stringSort).toString();
      if (sortedOrigin !== sortedCompare) return true;
      return false;
    }

    // 둘중 하나만 존재하는 경우
    return true;
  },
};

export default createTopicUtils;
